var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row q-gutter-sm"},_vm._l((_vm.items),function(item){return _c('q-skeleton',{key:item,attrs:{"type":"QChip","animation":_vm.animation,"width":_vm.width(20, item%2 == 0 ? 40 : 60) + '%'}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }